import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import qs from 'qs';
import replaceParamsInURL from './replaceParamsInURL';

var makeAction = function makeAction(serviceDeclaration, actionDeclaration, actionTypesForActionDeclaration, syncActionsForActionDeclaration, fetchFunction) {
  return function (params, fetchOptions) {
    return function (dispatch, getState) {
      dispatch(syncActionsForActionDeclaration.START_FETCHING());
      serviceDeclaration.onStartFetching && serviceDeclaration.onStartFetching(actionDeclaration, dispatch, getState);
      var actionDeclarationWithoutName = Object.entries(actionDeclaration).reduce(function (r, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        return key !== 'name' ? _objectSpread({}, r, _defineProperty({}, key, val)) : r;
      }, {});

      var fetchOptionsFromActionDeclarationAndActionCall = _objectSpread({}, actionDeclarationWithoutName, {}, fetchOptions);

      var url = serviceDeclaration.url;

      var _replaceParamsInURL = replaceParamsInURL(url, params),
          urlWithParamsFilled = _replaceParamsInURL.url,
          paramsWithoutUrlOnes = _replaceParamsInURL.params;

      var queryString = qs.stringify(paramsWithoutUrlOnes);
      var urlWithParamsFilledAndQueryString = urlWithParamsFilled + (queryString ? '?' + queryString : '');
      return fetchFunction(urlWithParamsFilledAndQueryString, fetchOptionsFromActionDeclarationAndActionCall).then(function (rawData) {
        var data = rawData;

        if (typeof serviceDeclaration.transformer === 'function') {
          var transformer = serviceDeclaration.transformer;
          data = transformer(rawData, actionDeclaration);
        }

        dispatch(syncActionsForActionDeclaration.RECEIVES_DATA(data, rawData));
        serviceDeclaration.onReceivesData && serviceDeclaration.onReceivesData(actionDeclaration, dispatch, getState);
        return data;
      }).catch(function (error) {
        dispatch(syncActionsForActionDeclaration.ERROR(error));
        serviceDeclaration.onError && serviceDeclaration.onError(actionDeclaration, dispatch, getState);
        return Promise.reject(error);
      }).finally(function () {
        dispatch(syncActionsForActionDeclaration.STOP_FETCHING());
        serviceDeclaration.onStopFetching && serviceDeclaration.onStopFetching(actionDeclaration, dispatch, getState);
      });
    };
  };
};

var makeActions = function makeActions(serviceDeclaration, actionTypesForService, syncActionsForService, fetchFunction) {
  return serviceDeclaration.actionsDeclarations.reduce(function (r, actionDeclaration, i) {
    return _objectSpread({}, r, _defineProperty({}, actionDeclaration.name, makeAction(serviceDeclaration, actionDeclaration, actionTypesForService[actionDeclaration.name], syncActionsForService[actionDeclaration.name], fetchFunction)));
  }, {});
};

export default (function (servicesDeclarations, actionTypes, syncActions, fetchFunction) {
  return servicesDeclarations.reduce(function (r, serviceDeclaration, i) {
    return _objectSpread({}, r, _defineProperty({}, serviceDeclaration.name, makeActions(serviceDeclaration, actionTypes[serviceDeclaration.name], syncActions[serviceDeclaration.name], fetchFunction)));
  }, {});
});